module.exports = __webpack_public_path__ + "img/2022.2十四五.b46960a9.png";